var React = require('react');
var RouteHandlerMixin = require('../RouteHandlerMixin');

/**
 * A <RouteHandler> component renders the active child route handler
 * when routes are nested.
 */
var RouteHandler = React.createClass({

  displayName: 'RouteHandler',

  mixins: [ RouteHandlerMixin ],

  render: function () {
    return this.createChildRouteHandler();
  }

});

module.exports = RouteHandler;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/modules/components/RouteHandler.js
 ** module id = 59
 ** module chunks = 0
 **/